export default __webpack_public_path__ + "static/media/profileIcon.801e5c53.svg";